/*
 * @Author: Teemo Ding
 * @Date: 2021-09-09 16:11:10
 * @LastEditTime: 2021-10-20 13:49:38
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Stock/data/sotckInfo.ts
 */
import _ from 'lodash';
import { generateErrorKey } from 'src/tools/helper';
export const stockInfoCheck = (info) => {
  const _i = _.cloneDeep(info);
  let flag;
  if (!(_i.supplier && _i.supplier.uuid)) {
    _i[generateErrorKey('supplier')] = true;
    flag = true;
  }
  if (!(_i.warehouse && _i.warehouse.uuid)) {
    _i[generateErrorKey('warehouse')] = true;
    flag = true;
  }

  return { data: _i, flag };
};
